import { QGetOpenBetsInfo } from "./QGetOpenBetsInfo";
import { QGetCashOutOperations } from "./GetCashOutOperations";
export const OpenBetsQueryBuilder = {
    getOpenBetsInfo: QGetOpenBetsInfo,
    getCashOutOperations: QGetCashOutOperations
};
//# sourceMappingURL=index.js.map